import {Component, inject} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {DataSources} from "@services";
import {OrderLinesGridComponent} from "../order-lines/order-lines-grid.component";

@Component({
    selector: 'app-load',
    standalone: true,
    imports: [OrderLinesGridComponent],
    template: `
        <div class="pt-3">
            <app-order-lines-grid
                [dataSource]="dataSource"
                [gridTitle]="'Line Items — ' + number"
                [gridId]="'loadLinesGrid'"
                [storageKey]="'load-lines-grid-state'"
                [gridHeight]="'calc(100vh - 97px)'"
                [exportFileName]="'Load Line Items'"
                [showBackButton]="true"
                (backClick)="back()"
            ></app-order-lines-grid>
        </div>
    `
})
export class LoadComponent {
    private route = inject(ActivatedRoute);
    private location = inject(Location);
    private dataSources = inject(DataSources);

    readonly number = this.route.snapshot.paramMap.get('number');

    dataSource = this.dataSources.loadLines(this.number);

    back = (): void => this.location.back();
}
